import BaseService from "./base.service";

class StatusService extends BaseService {
  constructor() {
    super("status");
  }
}

export default new StatusService();
